import { fetchSubscriptionPlans } from './effects';
import { $subscriptionPlans } from './states';

// Fetch subscription plans
$subscriptionPlans.on(fetchSubscriptionPlans.doneData, (_, data) => ({ ...data }));
